import i18next from "i18next";
import { initReactI18next } from "react-i18next";
import HttpApi from "i18next-http-backend";

// Helper function to get the base path dynamically
const getBasePath = (): string => {
  // If REACT_APP_ROUTER_BASENAME is set to a non-root path (from build time), use it
  // We exclude "/" because we want to handle root deployments at runtime
  if (
    process.env.REACT_APP_ROUTER_BASENAME &&
    process.env.REACT_APP_ROUTER_BASENAME !== "/"
  ) {
    return process.env.REACT_APP_ROUTER_BASENAME;
  }

  // Otherwise, calculate it from the current URL at runtime
  // This handles cases where the app is deployed to a subdirectory
  const { pathname } = window.location;

  // If pathname contains 'preview', extract the preview path
  const previewMatch = pathname.match(/^\/preview\/(\d+)/);
  if (previewMatch) {
    return `/preview/${previewMatch[1]}`;
  }

  // Default to root - return empty string to generate absolute paths from domain root
  return "";
};

export const useI18Next = () => {
  const initTranslation = (lng?: string) =>
    i18next
      .use(initReactI18next)
      .use(HttpApi)
      .init({
        compatibilityJSON: "v3",
        lng,
        load: "currentOnly",
        fallbackLng: false,
        backend: {
          loadPath: `${getBasePath()}/assets/locales/{{lng}}.json`,
        },
        react: { useSuspense: true },
      });

  return { i18next, initTranslation };
};
